import { render, staticRenderFns } from "./ChatOferta.vue?vue&type=template&id=99fefe00&scoped=true"
import script from "./ChatOferta.vue?vue&type=script&lang=js"
export * from "./ChatOferta.vue?vue&type=script&lang=js"
import style0 from "./ChatOferta.vue?vue&type=style&index=0&id=99fefe00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fefe00",
  null
  
)

export default component.exports